import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { translate } from 'react-jhipster';
import { formatterDate } from 'app/shared/util/date-utils';
import ComponentDatePicker from 'app/shared/component/ComponentDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheckCircle, faExclamationTriangle, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { colors } from 'app/config/color';
import {
  ENP,
  BORN_PLACE,
  NATIVE_VILLAGE,
  RESIDENT,
  APP_LOCAL_DATE_FORMAT,
  SUCCESS,
  IND,
  ORG,
  ADD,
  Resources,
  claim,
  KEY_STORAGE
} from 'app/config/constants';
import ModalSelectInfo from './modal-select-info';
import {
  getDistrict,
  getGuild,
  updateAttribute,
  uploadFile,
  getFile,
  appovalCreate,
  updateAccount,
  handleGetUserInfo
} from '../user.reducer';
import '../../user/profile.scss';
import moment from 'moment';
import MessageModal from 'app/shared/message/message-modal';
import MessageModalConfirm from '../../user/messageModalConfirm';
import ModalResources from './modal-resources';
import ModalUpdateAttribute from '../modal-update-attribute';
import AlertMessage from 'app/view-common/AlertMessage';
import ModalListFile from 'app/modules/account/user/identity-info/modal-list-file';
import { forEach } from 'lodash';
import { handleDeleteUserByIdApprove } from 'app/modules/administration/approve-management/approve-management.reducer';
import { handleRegisterUpload } from 'app/modules/account/register/register.reducer';

export interface IAddIdentityProps extends StateProps, DispatchProps {
  isDisplay: boolean;
  infoUserProfile: any;
  invokeCloseModal: Function;
}

export interface IAddIdentityState {
  birthday: Date;
  requiredDate: boolean;
  isDisplayModalSelectInfo: boolean;
  typeInput: string;
  isClearBirthPlace: boolean;
  isClearOriginLocal: boolean;
  isClearPermanentAddress: boolean;
  isClearCurrentAddress: boolean;
  birthPlace: string;
  originLocal: string;
  permanentAddress: string;
  currentAddress: string;
  showMessageUpdateInfo: boolean;
  disabelBtnUpdate: boolean;
  isDisplayModalConfirm: boolean;
  messageConfirm: string;
  dataInput: any;
  isChangeBirthPlace: boolean;
  isChangeOriginLocal: boolean;
  isChangePermanentAddress: boolean;
  isChangeCurrentAddress: boolean;
  displayModalResources: boolean;
  infoIdentity: any;
  showModalAttribute: boolean;
  showMessageError: boolean;
  messageError: string;
  stringType: string;
  showMessage: boolean;
  fileComputer: any;
  displayModalListFile: boolean;
  isVerifyResidentialFail: boolean;
  visible: boolean;
  color: string;
  message: string;
  selectedFiles: File[];
  errorMessage: string;
}

var HOMETOWN = 'homeTown';
var arrKeyIND = ['cn', 'gender', 'dateOfBirth', 'birthPlace', 'identity', 'citizenId', 'originLocal', 'permanentAddress', 'mobile', 'mail'];
var arrKeyENP = ['organization', 'tax', 'mobile', 'mail', 'add'];
var arrKeyORG = ['organization', 'unitCode', 'mobile', 'mail', 'add', 'unit'];
// info send to modal select info
var valueProvince = '';
var valueDistrict = '';
var valueWard = '';
var valueAddress = '';
var isUpdateInfo = false;
var arrWard = [];
var arrDistrict = [];
const BIRTH_PLACE = 'birthPlace';
var updateInfoWithResouce = false;
var sources = '';
var oldData = {};

export class AddIdentity extends React.Component<IAddIdentityProps, IAddIdentityState> {
  state: IAddIdentityState = {
    visible: false,
    color: 'danger',
    message: '',
    birthday: null,
    requiredDate: false,
    isDisplayModalSelectInfo: false,
    typeInput: '',
    isClearBirthPlace: false,
    isClearOriginLocal: false,
    isClearPermanentAddress: false,
    isClearCurrentAddress: false,
    birthPlace: '',
    originLocal: '',
    permanentAddress: '',
    currentAddress: '',
    showMessageUpdateInfo: false,
    disabelBtnUpdate: false,
    isDisplayModalConfirm: false,
    messageConfirm: '',
    dataInput: {},
    isChangeBirthPlace: false,
    isChangeOriginLocal: false,
    isChangePermanentAddress: false,
    isChangeCurrentAddress: false,
    displayModalResources: false,
    infoIdentity: null,
    showModalAttribute: false,
    showMessageError: false,
    messageError: '',
    stringType: '',
    showMessage: false,
    displayModalListFile: false,
    fileComputer: null,
    isVerifyResidentialFail: false,
    selectedFiles: [],
    errorMessage: ''
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.resDeleteUserApprove !== nextProps.resDeleteUserApprove) {
      this.setState({
        showMessageError: true,
        messageError: 'Hủy đăng ký thành công'
      });
      this.props.handleGetUserInfo(this.props.userProfile.login, 'EDIT', 'PENDING_APPROVAL');
    }

    if (this.props.resultData != nextProps.resultData) {
      if (nextProps.resultData.status == 'SUCCESS') {
        this.setState({
          displayModalResources: false,
          infoIdentity: null,
          showMessage: true
        });
        setTimeout(() => {
          this.setState({
            showMessage: false,
            displayModalResources: false
          });
        }, 2000);
        this.props.invokeCloseModal();
      }
    }

    if (this.props.resultUpdate != nextProps.resultUpdate) {
      if (nextProps.resultUpdate.status == 'SUCCESS') {
        this.setState({
          displayModalResources: false,
          infoIdentity: null,
          showMessage: true
        });
        setTimeout(() => {
          this.setState({
            showMessage: false,
            displayModalResources: false
          });
        }, 2000);
        this.props.invokeCloseModal();
      } else if (nextProps.resultUpdate) {
        this.setState({
          visible: true,
          message: nextProps.resultUpdate.message
        });
      }
    }
  }

  toggle = () => {
    this.setState({
      isClearBirthPlace: false,
      isClearOriginLocal: false,
      isClearPermanentAddress: false,
      isClearCurrentAddress: false,
      isChangeBirthPlace: false,
      isChangeOriginLocal: false,
      isChangePermanentAddress: false,
      isChangeCurrentAddress: false,
      birthday: null,
      requiredDate: false
    });
    this.props.invokeCloseModal();
  };
  handleValidSubmitIdentityInfo = (event, values) => {
    updateInfoWithResouce = true;
    if (this.props.userProfile.userType == IND) {
      if (this.state.birthday == null && !values.dateOfBirth) {
        this.setState({
          requiredDate: true
        });
        return;
      } else {
        this.setState({
          requiredDate: false
        });
      }
      values.dateOfBirth = this.state.birthday ? new Date(this.state.birthday).toISOString() : new Date(values.dateOfBirth).toISOString();
    }
    values.file = this.props.responseUpload;
    this.props.updateAccount(values);
    // this.setState({
    //   displayModalResources: true,
    //   infoIdentity: values
    // });
  };

  updateInfo = values => {
    if (this.props.infoUserProfile && this.props.infoUserProfile.attributes) {
      this.props.infoUserProfile.attributes.map(item => {
        Object.keys(values).map(function(key) {
          if (item.name === key && key === 'dateOfBirth') {
            item.value = moment(values[key]).format(APP_LOCAL_DATE_FORMAT);
            return;
          }
          if (item.name === key) {
            item.value = values[key] ? values[key].trim() : values[key];
            if (item.id == '') {
              item.id = null;
            }
            return;
          }
        });
      });
    }
    this.props.updateAttribute(this.props.infoUserProfile.attributes, null, null, null);
    event.preventDefault();
    this.setState({
      disabelBtnUpdate: true
    });
  };

  handleuploadFile = (values, file, type) => {
    // upload file
    if (type == 'COM') {
      values.active = 0;
      this.props.uploadFile(values, file);
    }
  };

  handleInvalidSubmit = (event, errors, values) => {
    if (errors) {
      window['autoFocus'](errors[0]);
    }
  };
  handleChangeDate = date => {
    this.setState({
      birthday: date,
      requiredDate: false
    });
  };
  markStarOfString = (name, lbl) => {
    if (this.props.userProfile.userType === IND) {
      // case citizens
      switch (name) {
        case 'cn':
        case 'gender':
        case 'dateOfBirth':
        case 'birthPlace':
          // case 'mobile':
          return (
            <label>
              {lbl} <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        case 'mobile':
          return <label>{lbl}</label>;
        case 'identity':
          return <label>Số CMT (9 số)</label>;
        case 'citizenId':
          return <label>Số CMT/CCCD</label>;
        case 'originLocal':
        case 'permanentAddress':
        case 'mail':
          return <label>{lbl}</label>;
        default:
          return;
      }
    } else if (this.props.userProfile.userType === ENP) {
      // company
      switch (name) {
        case 'organization':
          return (
            <label style={{ fontSize: '17px' }}>
              {lbl} <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        case 'tax':
        case 'mail':
        case 'add':
          return (
            <label>
              {lbl} <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        case 'mobile':
          return <label>{lbl}</label>;
        default:
          return;
      }
    } else if (this.props.userProfile.userType === ORG) {
      // company
      switch (name) {
        case 'organization':
        case 'unitCode':
        case 'mail':
          return (
            <label>
              {lbl} <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        case 'unit':
        case 'mobile':
        case 'add':
          return <label>{lbl}</label>;
        default:
          return;
      }
    } else {
      return '';
    }
  };
  resetValues = () => {
    valueProvince = '';
    valueDistrict = '';
    valueWard = '';
    valueAddress = '';
    isUpdateInfo = false;
    arrWard = [];
    arrDistrict = [];
  };

  renderButton = () => {
    return (
      <Button
        style={{ marginBottom: '13px' }}
        className={window.innerWidth < 500 ? 'btn-identity-mobile' : 'btn-identity-web'}
        type="submit"
        onClick={() => this.setState({ stringType: claim.IDENTITY })}
        disabled={this.state.disabelBtnUpdate}
        block
      >
        <span>Cập nhật</span>
      </Button>
    );
  };
  renderInputUpdate = (item, dataRequest) => {
    switch (item.name) {
      case 'cn':
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            validate={{
              required: { value: true, errorMessage: translate('register.messages.validate.fullname.required') },
              maxLength: { value: 50, errorMessage: translate('register.messages.validate.fullname.maxLength') }
            }}
            readOnly={true}
          />
        );
      case 'gender':
        return (
          <AvField
            name={item.name}
            type="select"
            value={item.value}
            validate={{
              required: { value: true, errorMessage: translate('register.messages.validate.gender.required') }
            }}
            readOnly={item.value ? true : false}
          >
            <option value="">{translate('global.form.gender.placeholder')}</option>
            <option value={1}>Nam</option>
            <option value={2}>Nữ</option>
          </AvField>
        );
      case 'identity':
        // if (item.value != null) {
        //   if (item.value != 'Chờ phê duyệt') {
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            validate={{
              pattern: {
                value: '^([0-9]{9})+$',
                errorMessage: 'Số cmt phải có 9 kí tự số'
              },
              maxLength: { value: 9, errorMessage: '' }
            }}
            readOnly={true}
          />
        );
      //   } else {
      //     return <label style={{ color: '#ff7518c7', fontSize: '18px', fontWeight: 'bold' }}>Chờ phê duyệt</label>;
      //   }
      // } else {
      //   return this.renderButton();
      // }

      case 'citizenId':
        // if (item.value != null) {
        //   if (item.value != 'Chờ phê duyệt') {
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            // validate={{
            //   pattern: {
            //     value: '^([0-9]{12})+$',
            //     errorMessage: 'Số cmt/cccd (12 số) phải có 12 kí tự số.'
            //   },
            //   maxLength: { value: 12, errorMessage: translate('register.messages.validate.cmt/cccd.minlength') }
            // }}
            readOnly={true}
          />
        );
      //   } else {
      //     return <label style={{ color: '#ff7518c7', fontSize: '18px', fontWeight: 'bold' }}>Chờ phê duyệt</label>;
      //   }
      // } else {
      //   return this.renderButton();
      // }

      case 'unitCode':
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            validate={{
              required: { value: true, errorMessage: 'Bạn phải nhập mã đơn vị' },
              maxLength: { value: 20, errorMessage: 'Mã đơn vị quá dài' }
            }}
            readOnly={item.value ? true : false}
          />
        );
      case 'dateOfBirth':
        let _value = new Date(formatterDate(item.value)).toDateString() != 'Invalid Date' ? new Date(formatterDate(item.value)) : null;
        return (
          <div>
            <div className="hiddenDate">
              <AvField name={item.name} value={formatterDate(item.value)} type="hidden" />
            </div>
            <ComponentDatePicker
              name=""
              value={this.state.birthday ? this.state.birthday : _value}
              required={this.state.requiredDate}
              handleChange={this.handleChangeDate}
              label=""
              placeHolder="dd/mm/yyyy"
              readOnly={item.value ? true : false}
            />
          </div>
        );
      case 'tax':
        if (this.props.userProfile.userType === '2') {
          return (
            <AvField
              name={item.name}
              value={item.value}
              type="text"
              validate={{
                required: {
                  value: this.props.userProfile.userType === ENP ? true : false,
                  errorMessage: translate('register.messages.validate.tax.required')
                },
                maxLength: { value: 50, errorMessage: translate('register.messages.validate.tax.maxLength') }
              }}
              readOnly={true}
            />
          );
        } else {
          return;
        }
      case 'mobile':
        return (
          <AvField
            name={item.name}
            value={dataRequest && dataRequest.mobile ? dataRequest.mobile : item.value}
            validate={{
              // required: {
              //   value: this.props.userProfile.userType == IND ? true : false,
              //   errorMessage: 'Bạn phải nhập số điện thoại.'
              // },
              number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') },
              minLength: { value: 10, errorMessage: translate('global.messages.validate.mobile.minlength') },
              maxLength: { value: 11, errorMessage: translate('global.messages.validate.mobile.maxlength') },
              pattern: { value: '^[0-9]+$', errorMessage: 'Số điện thoại không được chứa khoảng trắng' }
            }}
            autoComplete="off"
            readOnly={item.value ? true : false}
          />
        );
      case 'mail':
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="email"
            validate={{
              required: {
                value: this.props.userProfile.userType === ENP ? true : false,
                errorMessage: translate('register.messages.validate.email.required')
              },
              email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') },
              maxLength: { value: 250, errorMessage: translate('register.messages.validate.email.maxLength') }
            }}
            readOnly={item.value ? true : false}
          />
        );
      case 'organization':
        if (this.props.userProfile.userType == ENP || this.props.userProfile.userType === ORG) {
          return (
            <AvField
              name={item.name}
              value={item.value}
              type="text"
              validate={{
                required: {
                  value: true,
                  errorMessage:
                    this.props.userProfile.userType == ENP
                      ? translate('register.messages.validate.companyName.required')
                      : 'Bạn phải nhập tên tổ chức.'
                },
                maxLength: { value: 250, errorMessage: translate('register.messages.validate.companyName.maxLength') }
              }}
              readOnly={true}
            />
          );
        } else {
          return;
        }
      case 'unit':
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            validate={{
              // required: { value: true, errorMessage: translate('register.messages.validate.unit.required') },
              maxLength: { value: 250, errorMessage: translate('register.messages.validate.unit.maxLength') }
            }}
            readOnly={item.value ? true : false}
          />
        );
      default:
        return;
    }
  };
  renderIcon = (attrLoa, value) => {
    return null;
    // if (value) {
    //   if (attrLoa) return <FontAwesomeIcon icon={faCheckCircle} color={colors.colorSuccess} />;
    //   return <FontAwesomeIcon icon={faExclamationTriangle} color={colors.colorWarning} />;
    // }
    // return <FontAwesomeIcon icon={faArrowAltCircleRight} color={colors.colorDanger} />;
  };
  closeModalSelectInfo = () => {
    this.setState({
      isDisplayModalSelectInfo: false
    });
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  invokeCloseModalConfirm = () => {
    this.setState({
      isDisplayModalConfirm: false
    });
  };
  invokeAgree = () => {
    this.setState({
      isDisplayModalConfirm: false
    });
    this.updateInfo(this.state.dataInput);
  };
  filterIdentityInfoWithUserType = type => {
    if (type == IND) {
      return this.props.infoUserProfile && this.props.infoUserProfile.attributes
        ? this.props.infoUserProfile.attributes.filter(
            item =>
              item.name == 'cn' ||
              item.name == 'identity' ||
              item.name == 'citizenId' ||
              item.name == 'dateOfBirth' ||
              item.name == 'mobile' ||
              item.name == 'mail'
          )
        : [];
    } else if (type == ENP) {
      return this.props.infoUserProfile && this.props.infoUserProfile.attributes
        ? this.props.infoUserProfile.attributes.filter(item => item.name == 'organization' || item.name == 'tax')
        : [];
    } else if (type == ORG) {
      return this.props.infoUserProfile && this.props.infoUserProfile.attributes
        ? this.props.infoUserProfile.attributes.filter(
            item => item.name == 'organization' || item.name == 'unitCode' || item.name == 'mobile' || item.name == 'mail'
          )
        : [];
    } else {
      return [];
    }
  };

  closeModalResources = () => {
    this.setState({
      displayModalResources: false
    });
  };
  closeModalAttributed = () => {
    this.setState({
      showModalAttribute: false,
      birthday: null
    });
    this.props.invokeCloseModal();
  };
  closeAlert = () => {
    this.setState({
      showMessageError: false,
      displayModalResources: false,
      messageError: ''
    });
    this.props.invokeCloseModal();
  };

  cancelRequest = () => {
    this.props.handleDeleteUserByIdApprove(this.props.resUserInfoApprove[0].id);
  };

  handleFileChange = event => {
    const files = Array.from<File>(event.target.files);
    if (files.length > 0) {
      // Kiểm tra định dạng tệp (chỉ cho phép ảnh)
      const validTypes = ['application/pdf', 'application/doc', 'application/docx', 'image/jpg', 'image/jpeg', 'image/png'];
      console.log(files[0].type);
      if (!validTypes.includes(files[0].type)) {
        this.setErrorMessage('Tệp đính kèm không đúng định dạng.');
        return;
      }

      // Kiểm tra kích thước tệp (tối đa 5MB)
      const maxSizeInBytes = 5 * 1024 * 1024; // 5MB
      if (files[0].size > maxSizeInBytes) {
        this.setErrorMessage('Tệp đính kèm dung lượng vượt quá 5MB.');
        return;
      }

      this.setState({ selectedFiles: files });
      const formData = new FormData();
      formData.append('file', files[0]);
      this.props.handleRegisterUpload(formData);
    }
  };

  removeSelectedFile = () => {
    this.setState({ selectedFiles: [] });
  };

  setErrorMessage(message) {
    this.setState({
      visible: true,
      color: 'danger',
      message: message
    });
  }

  render() {
    var dataRequest = null;
    if (this.props.resUserInfoApprove && this.props.resUserInfoApprove.length > 0) {
      dataRequest = JSON.parse(this.props.resUserInfoApprove[0].requestData);
    }

    return (
      <div className="container-fluid">
        <MessageModal
          type={SUCCESS}
          showModal={this.state.showMessage}
          message={'Gửi duyệt thành công ! thông tin sẽ được chuyển đến quản trị viên phê duyệt.'}
        />

        <MessageModal type={SUCCESS} showModal={this.state.showMessageUpdateInfo} message={'Chúc mừng bạn đã cập nhật thành công.'} />
        <MessageModalConfirm
          showModalConfirm={this.state.isDisplayModalConfirm}
          invokeCancel={this.invokeCloseModalConfirm}
          message={this.state.messageConfirm}
          invokeAgree={this.invokeAgree}
        />
        <ModalUpdateAttribute
          display={this.state.showModalAttribute}
          attribute={this.props.resUpdateAttr}
          handleClose={this.closeModalAttributed}
          verifyResidentailFail={this.state.isVerifyResidentialFail}
        />

        <AlertMessage showModal={this.state.showMessageError} message={this.state.messageError} closeAlert={this.closeAlert} />
        <Modal
          className="modal-lg hide-border-bottom-modal"
          isOpen={this.props.isDisplay}
          toggle={this.toggle}
          size="lg"
          backdrop="static"
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '90%' }}
        >
          <ModalHeader toggle={this.toggle}>
            <h3 className="font-weight-bold">Đăng ký bổ sung thông tin tài khoản</h3>
          </ModalHeader>
          <ModalBody className="custom-scrollbar" style={{ paddingTop: '0px', height: '550px', overflow: 'auto' }}>
            {/*<div style={{ textAlign: 'center' }}>*/}
            {/*  <label className="font-weight-bold">Thông tin định danh</label>*/}
            {/*</div>*/}
            <Alert id="myAlert" color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
            <AvForm id="updateUser-form" onValidSubmit={this.handleValidSubmitIdentityInfo} onInvalidSubmit={this.handleInvalidSubmit}>
              <div style={{ border: '1px solid #C9C9C9', padding: '15px', marginBottom: '20px' }}>
                {this.filterIdentityInfoWithUserType(this.props.userProfile.userType).map((item, index) => (
                  <div className="row">
                    <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>{this.markStarOfString(item.name, item.label)}</div>
                    <div className={window.innerWidth < 768 ? 'col-10' : 'col-sm-6'}>{this.renderInputUpdate(item, dataRequest)}</div>
                  </div>
                ))}
                <div className="row">
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                    <label>Giấy tờ đính kèm</label>
                  </div>
                  <div className={window.innerWidth < 768 ? 'col-10' : 'col-sm-6'}>
                    <input
                      id="img-upload"
                      type="file"
                      multiple
                      accept="image/png, image/jpeg, image/jpg, image/heic, application/pdf"
                      onChange={e => this.handleFileChange(e)}
                      style={{ display: 'none' }}
                    />
                    <label htmlFor="img-upload" className="image-upload">
                      <div className="image-upload-content">Tải lên</div>
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                    <label />
                  </div>
                  <div className={window.innerWidth < 768 ? 'col-10' : 'col-sm-6'}>
                    {this.state.selectedFiles.length > 0 && (
                      <Row className="file-name">
                        <Col md="1">
                          <img src={require('app/images/paperclip.png')} alt="Paper Clip Icon" />{' '}
                        </Col>
                        <Col md="10">
                          {this.state.selectedFiles.map((file, index) => (
                            <span key={index}>
                              {file.name}
                              {index < this.state.selectedFiles.length - 1 ? ', ' : ''}
                            </span>
                          ))}{' '}
                        </Col>
                        <Col md="1">
                          <img src={require('app/images/X.png')} onClick={this.removeSelectedFile} />
                        </Col>
                      </Row>
                    )}
                    {this.state.errorMessage && <Alert color="danger">{this.state.errorMessage}</Alert>}
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className={window.innerWidth < 768 ? 'col-6' : 'col-sm-3'}>
                    <Button
                      className="btn-register-white"
                      style={{
                        float: 'right',
                        marginTop: '10px',
                        marginBottom: '10px',
                        height: '40px'
                      }}
                      type="button"
                      block
                      onClick={this.toggle}
                    >
                      <span>Bỏ qua</span>
                    </Button>
                  </div>

                  {!this.props.resUserInfoApprove || this.props.resUserInfoApprove.length == 0 ? (
                    <div className={window.innerWidth < 768 ? 'col-6' : 'col-sm-3'}>
                      <Button
                        className="btn-register"
                        style={{ marginTop: '10px', height: '40px' }}
                        type="submit"
                        disabled={this.state.disabelBtnUpdate}
                        block
                      >
                        <span>Cập nhật</span>
                      </Button>
                    </div>
                  ) : (
                    <div className={window.innerWidth < 768 ? 'col-6' : 'col-sm-3'}>
                      <Button
                        className="btn-register"
                        style={{ marginTop: '10px', height: '40px', backgroundColor: 'red', color: '#fff' }}
                        type="button"
                        disabled={this.state.disabelBtnUpdate}
                        onClick={this.cancelRequest}
                        block
                      >
                        <span>Hủy đăng ký</span>
                      </Button>
                    </div>
                  )}
                </div>
                {/*<div>*/}
                {/*  <Button*/}
                {/*    className="btn-register"*/}
                {/*    style={{ margin: '10px auto', width: window.innerWidth < 768 ? '50%' : '20%' }}*/}
                {/*    type="submit"*/}
                {/*    onClick={() => this.setState({ stringType: 'null' })}*/}
                {/*    disabled={this.state.disabelBtnUpdate}*/}
                {/*    block*/}
                {/*  >*/}
                {/*    <span>Cập nhật</span>*/}
                {/*  </Button>*/}
                {/*</div>*/}
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  arrProvince: storeState.userInfo.province,
  district: storeState.userInfo.district,
  guild: storeState.userInfo.guild,
  userProfile: storeState.userInfo.userProfile,
  resUpdateAttr: storeState.userInfo.resUpdateAttr,
  approval: storeState.userInfo.appovalData,
  resultData: storeState.userInfo.resultData,
  listFile: storeState.userInfo.listFile,
  resultUpdate: storeState.userInfo.resultUpdate,
  resUserInfoApprove: storeState.userInfo.resInfoApprove,
  resDeleteUserApprove: storeState.approveManagement.resDeleteUserApprove,
  responseUpload: storeState.register.responseUpload
});
const mapDispatchToProps = {
  getDistrict,
  getGuild,
  updateAttribute,
  uploadFile,
  getFile,
  appovalCreate,
  updateAccount,
  handleDeleteUserByIdApprove,
  handleGetUserInfo,
  handleRegisterUpload
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddIdentity);
